import { Link } from 'react-router-dom'

const COPYRIGHT_YEAR = 2026

const quickLinks = [
  { label: 'My Story', href: '#journey-section' },
  { label: 'GLP-1 Insights', href: '#glp1-info-section' },
  { label: 'Process', href: '#how-it-works-section' },
  { label: 'FAQ', href: '#faq-section' },
  { label: 'Contact', href: '#contact' },
]

const Footer = () => {
  return (
    <footer className="bg-[#cdfbf1] text-slate-700">
      <div className="container mx-auto px-6 py-16">
        <div className="grid gap-10 lg:grid-cols-4">
          <div>
            <p className="text-xs uppercase tracking-[0.6em] text-teal-700">Andrea Villalobos</p>
            <h3 className="mt-3 text-2xl font-semibold text-slate-900">GLP-1 + Longevity guide</h3>
            <p className="mt-4 text-sm text-slate-600">
              Grounded accountability, practical routines, and lifestyle support designed to make sustainable change feel calm.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.3em] text-slate-900">Navigate</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="hover:text-slate-900 transition">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.3em] text-slate-900">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href="mailto:info@andreavillalobos.com" className="hover:text-slate-900 transition">info@andreavillalobos.com</a></li>
              <li>Remote support + Los Angeles, California</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.3em] text-slate-900">Legal</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/terms-of-service" className="hover:text-slate-900 transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="hover:text-slate-900 transition">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-teal-200 py-6 text-center text-xs text-slate-500">
        &copy; {COPYRIGHT_YEAR} Andrea V. All rights reserved.
      </div>
    </footer>
  )
}

export default Footer
